export const deleteDocumentFiles = (payload?: any) => ({
    type: "@saga/DELETE_DOCUMENT_FILES",
    payload
});

